import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

import { usePromoteFormState } from '../../../../formContext';

type Result = ModelHookResult<{
	ref: RefObject<HTMLDivElement | null>;
}>;

export function useImpressionAmountSelector(): Result {
	const [{ validationErrors }] = usePromoteFormState();

	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (ref.current && validationErrors?.amount) ref.current.scrollIntoView();
	}, [validationErrors?.amount, ref]);

	return {
		data: {
			ref,
		},
	};
}
